import ShowInformation from "./ShowInformation";
import Approve from "./Approve";
import Search from "./Search";
import Filter from "./Filter";
import Create from "./Create";
import Update from "./Update";
import Reject from "./Reject";
import Body from "./Body";

const Components = {
  ShowInformation,
  Approve,
  Search,
  Filter,
  Create,
  Update,
  Reject,
  Body,
};

export default Components;
